import { UtilsService } from '../services';

module.exports = (date: any): any => {
	const dateValue = new Date(date);
	return UtilsService.formatDate(dateValue);
};
